<template>
  <div class="textme">
    <form class="textme-form"
      @submit.prevent="onSubmit">
      <div class="form-field">
        <label>Full Name</label>
        <input type="text" @blur="handleBlur"
          class="textme-form-input"
          v-model="fullName"
          placeholder="Full Name"
        />
        <label>Full Name</label>
      </div>
      <div class="form-field">
        <label>Email Address</label>
        <input type="email" @blur="handleBlur"
          class="textme-form-input"
          v-model="email"
          placeholder="Email Address"
        />
        <label>Email Address</label>
      </div>
      <div class="form-field">
        <label>Phone Number</label>
        <input type="text" @blur="handleBlur"
          class="textme-form-input"
          v-mask="'+1 (###) ###-####'"
          v-model="phoneNumber"
          placeholder="Phone Number"
        />
        <label>Phone Number</label>
      </div>
      <div class="form-field">
        <label>Course Name or Task</label>
        <input type="text" @blur="handleBlur"
          class="textme-form-input"
          v-model="courseName"
          placeholder="Course Name or Task"
        />
        <label>Course Name or Task</label>
      </div>
      <div class="form-recaptcha">
        <vue-recaptcha sitekey="6Le4DnUjAAAAAIIG8wF1MO4wluAWq6Zkk3dMDzux" @verify="verifyMethod" @expired="expiredMethod" @render="renderMethod" @error="errorMethod">
        </vue-recaptcha>
      </div>
      <div class="textme-form-button-wrapper">
        <button>Get Quote Now!</button>
      </div>
    </form>
  </div>
</template>

<script>
// import EventBus from '@/utils/event-bus'
import { VueRecaptcha } from 'vue-recaptcha'

export default {
  components: {
    VueRecaptcha
  },
  props: {
    border: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      errors: [],
      fullName: null,
      email: null,
      phoneNumber: null,
      courseName: null,
      recaptchaVerification: false
    }
  },
  methods: {
    handleBlur (e) {
      e.target.classList.remove('error')
      e.target.classList.remove('success')
      if (e.target.placeholder !== 'Email Address' && e.target.placeholder !== 'Phone Number' && !e.target.value) {
        e.target.classList.add('error')
      } else if (e.target.placeholder !== 'Email Address' && e.target.placeholder !== 'Phone Number' && e.target.value) {
        e.target.classList.remove('error')
        e.target.classList.add('success')
      }
      if (e.target.placeholder === 'Email Address' && !e.target.value) {
        e.target.classList.add('error')
      } else if (e.target.placeholder === 'Email Address' && e.target.value && !this.validEmail(this.email)) {
        e.target.classList.add('error')
      } else if (e.target.placeholder === 'Email Address' && e.target.value && this.validEmail(this.email)) {
        e.target.classList.remove('error')
        e.target.classList.add('success')
      }
      if (e.target.placeholder === 'Phone Number' && !e.target.value) {
        e.target.classList.add('error')
      } else if (e.target.placeholder === 'Phone Number' && e.target.value && e.target.value.length < 17) {
        e.target.classList.add('error')
      } else if (e.target.placeholder === 'Phone Number' && e.target.value && e.target.value.length > 16) {
        e.target.classList.remove('error')
        e.target.classList.add('success')
      }
    },
    onSubmit () {
      if (!this.recaptchaVerification) {
      }
      if (this.fullName && this.email && this.phoneNumber && this.courseName && this.recaptchaVerification) {
        // EventBus.$emit('OPEN_POPUP', true)

        // Adwords tracking
        this.$gtag.reportConversion({
          send_to: 'AW-722872910/4zLHCOfKgNgBEM7U2NgC' // the custom tag to be reported
        })

        // Facebook pixel tracking
        this.$analytics.fbq.event('Lead')

        fetch('/.netlify/functions/sendQuoteMailHome', {
          method: 'POST',
          cache: 'no-cache',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            fullName: this.fullName,
            email: this.email,
            phoneNumber: this.phoneNumber.replace(/[^0-9.]+/g, ''),
            courseName: this.courseName,
            currentURL: window.location.href
          })
        })
          .then(response => response.json())
          .then(json => {
            this.$router.push('thank-you')
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },

    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },

    verifyMethod () {
      this.recaptchaVerification = true
    },
    expiredMethod () {
      this.recaptchaVerification = false
    },
    renderMethod () {
      this.recaptchaVerification = false
    },
    errorMethod () {
      this.recaptchaVerification = false
    }
  }
}
</script>

<style lang="scss">
  @import '~@/styles/media';

  .textme {
    position: relative;

    &-form {

      label {
        font-size: 14px;
        font-family: 'ProximaNova-Regular';
        margin-bottom: 5px;
        display: block;

        &:nth-child(3) {
          display: none;
        }
      }

      &-input {
        border-radius: 13px;
        box-sizing: border-box;
        background: transparent;
        height: 49px;
        padding: 5px 5px 5px 13px;
        display: grid;
        grid-template-columns: 1fr auto;
        align-items: center;
        transition: box-shadow .2s ease-out;
        margin-bottom: 10px;
        font-size: 16px;
        border: none;
        outline: none;
        width: 100%;

        &:focus {
          box-shadow: none !important;
        }

        &.success {
          background-image: url('~@/assets/images/success.png') !important;
          background-repeat: no-repeat !important;
          background-position: 100% 6px !important;
        }

        &::-webkit-input-placeholder { /* Chrome/Opera/Safari */
          color: var(--primary-black);
          font-size: 0;
        }
        &::-moz-placeholder { /* Firefox 19+ */
          color: var(--primary-black);
          font-size: 0;
        }
        &:-ms-input-placeholder { /* IE 10+ */
          color: var(--primary-black);
          font-size: 0;
        }
        &:-moz-placeholder { /* Firefox 18- */
          color: var(--primary-black);
          font-size: 0;
        }
      }

      &-button-wrapper {
        width: 100%;

        & button {
          width: 100%;
        }
      }

      &-bordered {
        border: 1px solid #dbdbdb;
      }

      &-hovered {
        box-shadow: var(--basic-shadow);
      }

      button {
        background-color: var(--primary-green);
        color: var(--primary-white);
        border-radius: 5px;
        height: 46px;
        outline: none;
        padding: 0 25px;
        border: 0;
        font-size: 14px;
        cursor: pointer;
        transition: background-color .2s ease-out;
        margin-top: 15px;
        font-family: 'ProximaNova-Bold';

        &:hover {
          background-color: var(--primary-green-hover);
        }
      }

      .form-recaptcha {
        width: 100%;

        & > div > div {
          margin: 0 auto;
        }
      }
    }

    @media #{$xs} {
      input { font-size: 14px; }
      span { display: none; }
    }
    @media #{$sxs} {
      .form-recaptcha {
        overflow: hidden;
        iframe {
          scale: .8;
          margin-left: -30px;
        }
      }
    }
  }

  .home-header-left {
    .textme-form-input {
      background: var(--transparent);
      border: none;
      border-bottom: 2px solid #000100;
      font-family: 'ProximaNova-Bold';
      font-size: 17px;
      border-radius: 0;
      padding: 0;
      height: 35px;
      @media #{$sxs} {
        height: 22px;
      }
    }

    .textme-form button {
      height: 52px;
      box-shadow: 5px 5px 0px #d7bc61;
      font-size: 17px;
      border-radius: 5px;
      @media #{$sxs} {
        height: 48px;
      }
    }

    @media #{$sxs} {
      .textme-form {
        label {
          margin-bottom: 0;
        }
        &-input {
          &.success {
            background-position: 100% -2px !important;
          }
        }
      }
      .form-recaptcha {
        margin-top: -12px;
        margin-bottom: -14px;
      }
    }
  }
</style>
